import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';
import { useAppDataSliceSelector } from '../../store/modules/appData';
import { closeDialog } from '../../store/modules/dialog';
import { isDevicePC } from '../../utils/util';
import Button from '../common/Button';
import Dialog from './Dialog';

const DialogBody = styled.div`
  display: flex;
  height: 122px;
  flex-flow: column;
  align-items: center;
`;

const DialogComment = styled.div`
  width: ${(props) => props.width};
  height: 25px;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #2f3133;
  margin: 10px 12px 28px 12px;
`;

const PCButtonCss = css`
  min-width: 114px;
  padding-top: 5px;
  padding-bottom: 6px;
  font-weight: 700;
`;

const MobileButtonCss = css`
  height: 36px;
  min-width: 100px;
  padding-top: 5px;
  padding-bottom: 6px;
`;

function WhaleSpaceLoginDialog({ isShow, userName }) {
  const closeDispatch = useDispatch();
  const onClickCloseBtn = () => closeDispatch(closeDialog());
  const appDataSlice = useAppDataSliceSelector();
  const isPCView = isDevicePC(appDataSlice.deviceType);

  const commentWidth = isPCView === true ? '298px' : '256px';
  const buttonCss = isPCView === true ? PCButtonCss : MobileButtonCss;

  return (
    <Dialog isShow={isShow}>
      <DialogBody>
        <DialogComment width={commentWidth}>
          {userName}님 반갑습니다.
        </DialogComment>
        <Button primary cssExt={buttonCss} onClick={onClickCloseBtn}>
          확인
        </Button>
      </DialogBody>
    </Dialog>
  );
}

export default WhaleSpaceLoginDialog;
